import * as React from 'react';

import {LinkBlockItemActive} from '@app/objects/LinkBlockItem';

export const euthanasiaLinkItems: LinkBlockItemActive[] = [
	{
		path: '/our-services/veterinary-hospice',
		name: 'Veterinary Hospice',
	},
	{
		path: '/our-services/in-home-euthanasia',
		name: 'In-Home Euthanasia',
		active: true,
	},
	{
		path: '/our-services/aftercare',
		name: 'Aftercare',
	},
	{
		path: '/our-services/telehospice',
		name: 'Telehospice',
	},
	{
		path: '/our-services/pet-loss-support',
		name: 'Pet Loss Support',
	},
];

export const euthanasiaEmbedText = `
Ask any of the Lap of Love doctors, and we’ll tell you that the discussion of when to say goodbye is the hardest but 
most important conversation a veterinarian can have with the families we work with. Talking about death is a skill 
that takes empathy, openness, non-judgment, and compassion. And we consider it a privilege to have these tough 
conversations with people leading up to their pet's euthanasia at home.
`;

export const euthanasiaFiftyTitle = <>What to <span className="highlight">expect</span> from <br/> in-home
	euthanasia</>;
export const euthanasiaFiftyText = `
The word “euthanasia” literally means “good death”. 
As the only medical profession licensed to perform this gift, 
we take the utmost pride in having the technical, medical, 
and soft skills necessary to provide a peaceful end-of-life experience for your beloved pet.
`;

export const euthanasiaServicesTitle = 'Our in-home pet euthanasia services include:';
export const euthanasiaServices = (
	<ul>
		<li>A discussion about your concerns, thoughts, or questions surrounding in-home euthanasia.</li>
		<li>
			Sedation to ease discomfort; you deserve your final memory of your pet to be calm and comfortable. This
			injection of pain medication and sedatives will allow your pet to drift off to a peaceful sleep before the
			final injection is administered.
		</li>
		<li>
			Sedation assessment, to ensure your pet is sleeping deeply and no longer responds to stimulation.
		</li>
		<li>Euthanasia, the final gift.</li>
		<li>Memorial keepsakes to help mend the broken heart: a clay paw print (made at home) and a lock of fur, if
			desired.
		</li>
		<li>
			Pet Loss Booklet with your pet’s name and date of passing, which will serve as a
			death certificate. The booklet includes information on the way your other pets may
			grieve (if you have any), in addition to a few beautiful poems and stories.
		</li>
		<li>
			Transportation for cremation, if selected (see the Aftercare Pricing section on
			your veterinarian's page for more information).
		</li>
		<li>
			A courtesy notification to your family’s veterinarian of your pet’s passing for their records.
		</li>
	</ul>
);
export const appointmentInformation = (
	<>
		<p>
			Once the veterinarian arrives, the full procedure will be explained to you based on your interest and
			comfort level. Don’t be afraid to ask questions along the way—everything will be done at a pace that you and
			your pet dictate.
		</p>
		<p>
			In almost all circumstances, your pet will be given a sedation injection prior to the euthanasia injection.
		</p>
	</>
);

export const appointmentInformation2 = (
	<>
		<p>
			After the injection, you can spend as much time with your pet as you need. When you are ready, a paw print
			will be made. Additionally, your doctor will clip a lock of fur for you to keep, if you wish.
		</p>
		<p>
			If we are handling transportation for cremation, your doctor will excuse themselves to give you alone time,
			then return with a small basket, flat stretcher, or soft blanket to transport your pet to the car.
		</p>
		<p>
			Information on how and when your pet’s ashes will be ready to come home will be discussed by the doctor in
			detail. Additionally, information on where your local crematory spreads communal ashes or how to bury your
			pet properly at home is available.
		</p>
	</>
);

export const sliderItems = [
	{
		text: 'A Lap of Love veterinarian will arrive at your home for the in-home euthanasia appointment.  We don’t wear scrubs or a white coat, we arrive with the emotions that guide us to this work, warmth and compassion.  \n',
		src: require('@app/content/EuthanasiaSlider/Dr-Dani-Appt-1.jpg'),
		alt: 'Veterinarian end of life care',
	},
	{
		text: 'The veterinarian will talk you through the entire euthanasia process based on your interest and comfort level.  Please feel free to ask any questions to help you feel as comfortable as possible.  \n',
		src: require('@app/content/EuthanasiaSlider/Dr-Dani-Appt-2.jpg'),
		style: {objectPosition: 'top'},
		alt: 'Senior pet care',
	},
	{
		text: 'After the final euthanasia medication is given, the veterinarian will confirm that your pet has peacefully passed on.  This is, of course, the most delicate moment of our time with you.  Every family receives a paw print and fur clipping for an eternal keepsake.  A paw print is perhaps the most meaningful representation of your pet, the paw that was by your side for so long.\n  \n',
		src: require('@app/content/EuthanasiaSlider/Dr-Dani-Appt-3.jpg'),
		alt: 'In-home euthanasia paw print',
	},
	{
		text: 'When appropriate, we will leave your home and allow you to grieve in private.  (Aftercare options and information on how and when your pet’s ashes will be ready to come home will be discussed by the doctor in detail at the beginning of the appointment.)    \n',
		src: require('@app/content/EuthanasiaSlider/Dr-Dani-Appt-4.jpg'),
		alt: 'Sympathy for pet loss',
	}
];